import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSourceengineComponent } from './simple-icons-sourceengine.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSourceengineComponent ],
    exports:      [ SimpleIconsSourceengineComponent ],
    bootstrap:    []
})
export class SimpleIconsSourceengineModule {}
